import { render, staticRenderFns } from "./personalsummary.vue?vue&type=template&id=962df0d6&scoped=true"
import script from "./personalsummary.vue?vue&type=script&lang=js"
export * from "./personalsummary.vue?vue&type=script&lang=js"
import style0 from "./personalsummary.vue?vue&type=style&index=0&id=962df0d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962df0d6",
  null
  
)

export default component.exports